"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    desc: "<p>\n    \u0424\u043E\u0442\u043E\u0431\u043E\u043A\u0441\u044B \u044D\u0442\u043E \u0442\u0430\u043A\u0438\u0435 \u0442\u0440\u044F\u043F\u0438\u0447\u043D\u044B\u0435 \u044F\u0449\u0438\u043A\u0438 \u0434\u043B\u044F \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043D\u043E\u0439 \u0441\u044A\u0435\u043C\u043A\u0438\n  </p>",
};
